import React from "react";

import { ComponentLayout } from "../../support/ComponentLayout";
import { ComponentSectionLayout } from "../../support/ComponentSectionLayout";

export const ButtonGroupsDemo: React.FC<unknown> = () => {
  return (
    <ComponentLayout title={"Wip - Button Groups"}>
      <ComponentSectionLayout title={"default"}></ComponentSectionLayout>
    </ComponentLayout>
  );
};
